export default __webpack_public_path__ + "static/media/500.cae01814.jpg";